import type { ExpectedCloseV2CompanyForecast } from "../expected-close-v2/localExpectedCloseForecast";
import { prepareDealsForRiskAssessment } from "../lib/risk";

type PreparationArgs = Parameters<typeof prepareDealsForRiskAssessment>;

/** Keep V1's population intact; restore only open Deals with a ready V2 curve. */
export function includeV2ForecastOpenDeals({
  legacyOpenDeals, rawOpenDeals, companyForecast, pipelines, currencies, company, stageTimes,
}: {
  legacyOpenDeals: ReturnType<typeof prepareDealsForRiskAssessment>;
  rawOpenDeals: PreparationArgs[0];
  companyForecast: ExpectedCloseV2CompanyForecast | undefined;
  pipelines: PreparationArgs[1];
  currencies: PreparationArgs[2];
  company: PreparationArgs[3];
  stageTimes: PreparationArgs[4];
}) {
  if (!companyForecast) return legacyOpenDeals;
  const supportedIds = new Set(companyForecast.dealForecasts.map(deal => Number(deal.dealId)));
  const includedIds = new Set(legacyOpenDeals.map(deal => Number(deal.id)));
  const missingV2Deals = (rawOpenDeals ?? []).filter(deal =>
    !deal.is_closed && supportedIds.has(Number(deal.id)) && !includedIds.has(Number(deal.id)),
  );
  if (!missingV2Deals.length) return legacyOpenDeals;
  // Reuse currency, stage and pipeline handling, preparing only additional Deals.
  const additionalDeals = prepareDealsForRiskAssessment(
    missingV2Deals, pipelines, currencies, company, stageTimes,
    { preserveOverdueDealIds: supportedIds },
  );
  return [...legacyOpenDeals, ...additionalDeals];
}
